/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does Kelvin never use the degree symbol (°)?`)
};

const es_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué Kelvin nunca usa el símbolo de grado (°)?`)
};

const de_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum verwendet Kelvin nie das Gradzeichen (°)?`)
};

const nl_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom gebruikt Kelvin nooit het graden symbool (°)?`)
};

const fr_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi Kelvin n'utilise-t-il jamais le symbole du degré (°) ?`)
};

const it_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché Kelvin non usa mai il simbolo di grado (°)?`)
};

const pt_br2_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que Kelvin nunca usa o símbolo de grau (°)?`)
};

const pt_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que Kelvin nunca utiliza o símbolo de grau (°)?`)
};

const ja_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケルビンは度の記号(°)を使用しないのはなぜですか?`)
};

const zh_uc_temp_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_temp_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_temp_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_temp_faq2_q", locale)
	if (locale === "en") return en_uc_temp_faq2_q(inputs)
	if (locale === "es") return es_uc_temp_faq2_q(inputs)
	if (locale === "de") return de_uc_temp_faq2_q(inputs)
	if (locale === "nl") return nl_uc_temp_faq2_q(inputs)
	if (locale === "fr") return fr_uc_temp_faq2_q(inputs)
	if (locale === "it") return it_uc_temp_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_temp_faq2_q(inputs)
	if (locale === "pt") return pt_uc_temp_faq2_q(inputs)
	if (locale === "ja") return ja_uc_temp_faq2_q(inputs)
	return zh_uc_temp_faq2_q(inputs)
};